import { rem } from 'polished';
import Button from '../Button';
import React from 'react';
import styled from 'styled-components';
const Wrapper = styled(Button) `
  margin: 0 ${rem(4)};
  padding: 0 ${rem(7)};
  min-height: ${rem(40)};
  min-width: ${rem(40)};
  height: 100%;
`;
const Action = ({ children, as, ...props }) => {
    return (React.createElement(Wrapper, { ...props, forwardedAs: as }, children));
};
export default Action;
